export const { BASE_URL, API_URL, SOCKET_URL, SUBTITLES_API_URL, ROUTER_ROOT, PUBLIC_URL_ROOT } = process.env;

export const { SENTRY_DSN } = process.env;

export const ENABLE_SENTRY = process.env.ENABLE_SENTRY === 'true';

export const isProduction = process.env.NODE_ENV === 'production';
export const isDebugEnabled = process.env.DEBUG === 'true';
